Ext.ns('mx.comp');

mx.comp.mapComponent = Ext.extend(mx.comp.mapIFrameComponent, {
    mapParams: null,
    urls: {
        get_current_region: mx.PATH + MXAT.API('regions/current'),
        get_region: mx.PATH + MXAT.API('regions/'),
    },
    currentPointIcon: {
        url: MXAT.commonsPath + 'img/map/redstar.gif',
        width: 16,
        height: 15,
    },
    regionId: null, // override this, if you want to use region of specific id
    onRender: function(ct, position) {
        if (this.url == null) {
            //Ext demands some DOM el. to be loaded during render. We can't provide map at this point so give
            // it placeholder. The control will be empty until we get map key info
            this.el = ct.createChild({tag: 'div', id: 'placeholder-' + this.id});
        } else {
            if (this.el) {
                //if placeholder is installed
                this.el.remove(); //remove placeholder
            }
            mx.comp.mapComponent.superclass.onRender.call(this, ct, position);
        }
    },
    showMap: function() {
        this.setUrl(MXAT.commonsPath + 'map.html#' + Ext.urlEncode({params: this.mapParams.toArray().join('/')}));

        if (this.rendered) {
            //if rendered already
            this.rendered = false;
            this.ownerCt.doLayout(); //render component again
        }
    },
    retrieveRegion: function(regionId) {
        Ext.Ajax.request({
            url: regionId ? this.urls.get_region + regionId : this.urls.get_current_region,
            method: 'GET',
            success: function(response) {
                //decode response
                var decoded = Ext.util.JSON.decode(response.responseText);
                if (decoded.errors.length) {
                    mx.Util.displayError(decoded.errors[0].message, response.status);
                    return;
                }
                var region = decoded.rows[0];
                if (regionId) {
                    this.mapParams.setRegionAndPos(region);
                    this.showMap();
                } else {
                    //Dispatching screen, so use viewport cookie. Wait for user info to determine what cookie to use
                    mx.Application.onauthenticated(function() {
                        this.mapParams.setRegionAndPos(
                            region,
                            mx.Util.Cookies.decodeJsonCookie(application.getCookieName('MapView'))
                        );
                        this.showMap();
                    }, this);
                }
            },
            failure: function(response) {
                mx.Util.displayError(response.statusText, response.status);
            },
            scope: this,
        });
    },
    initComponent: function() {
        //in the case if provided mapParams are incomplete complete them with defaults
        this.mapParams = new mx.comp.MapParams(this.mapParams);
        if (this.mapParams.valid()) {
            if (this.mapParams.regionUnresolved()) {
                this.retrieveRegion(this.mapParams.region.get('id'));
            } else {
                this.showMap();
            }
        } else {
            this.retrieveRegion(this.regionId);
        }
        mx.comp.mapComponent.superclass.initComponent.apply(this, arguments);
    },
    updateCurrentPoint: function(point) {
        if (point.lon != '' && point.lat != '') {
            var currentPointId = 'currentPoint';
            var currentPoint = this.theMap.getMarkerById(currentPointId);
            if (currentPoint) {
                this.theMap.removeMarker(currentPoint);
            }
            currentPoint = new this.theMap.mxn.Marker(point);
            currentPoint.id = currentPointId;
            currentPoint.setIcon(this.currentPointIcon.url);
            currentPoint.setIconSize([this.currentPointIcon.width, this.currentPointIcon.height]);
            this.theMap.addMarker(currentPoint);
        }
    },
});

mx.comp.mapComponent.defaultRegionZoom = 3;
mx.comp.mapComponent.defaultDivisionZoom = 8;

mx.comp.mapComponent.getMapParamsFromRegDivision = function(regDivision) {
    var result = {
        region: regDivision.get('region'),
        zoom: mx.comp.mapComponent.defaultDivisionZoom,
    };
    if (regDivision.get('service_area')) {
        result.area = regDivision.get('service_area');
    } else {
        Ext.apply(result, mx.data.GeoPoint.geoToMxnPoint(regDivision.get('address')));
    }
    return result;
};

mx.comp.mapComponent.getRegDivision = function(regDivisionId) {
    var store = Ext.StoreMgr.lookup('for_map.divisions');
    return store.getAt(store.find('id', regDivisionId));
};

//ASSUMPTION: the store 'divisions' is already loaded
//TODO: pass store as param and assert its loaded
mx.comp.mapComponent.getMapParamsFromRegDivisionId = function(regDivisionId) {
    var regDivision = mx.comp.mapComponent.getRegDivision(regDivisionId);
    return mx.comp.mapComponent.getMapParamsFromRegDivision(regDivision);
};

mx.comp.mapComponent.getMapParamsFromAOC = function(aoc) {
    var result = {
        aoc: aoc.get('id'),
        area: aoc.get('area_data'),
        mapKey: aoc.get('map_key'),
        mapType: aoc.get('map_type'),
        mapIdAndUrl: aoc.get('map_id_and_url'),
        clientName: aoc.get('client_name'),
    };

    var partialDivision = aoc.get('division');
    var regDivision = mx.comp.mapComponent.getRegDivision(
        partialDivision.get ? partialDivision.get('id') : partialDivision.id
    );
    if (!regDivision && partialDivision['fullDivision']) {
        // quick hack for customer and supplier user roles
        regDivision = partialDivision['fullDivision'];
    }
    result.regionName = regDivision.get('region').get('name');
    if (!result.area) {
        Ext.apply(result, mx.comp.mapComponent.getMapParamsFromRegDivision(regDivision));
    }
    return result;
};

mx.comp.mapComponent.prepareDivisionsStore = function() {
    var store = mx.data.RegionalDivision.newStore({
        id: 'for_map.divisions',
        baseParams: {
            fillServiceArea: true,
        },
    });
    store.load();
};

mx.comp.mapComponent.getMapParamsFromAOCForCPF = function(aoc) {
    //todo: temporary solution to avoid exception
    var result = {
        aoc: aoc.get('id'),
        area: aoc.get('area_data'),
        mapKey: aoc.get('map_key'),
        mapType: aoc.get('map_type'),
    };
    return result;
};

Ext.reg('mapcomponent', mx.comp.mapComponent);

mx.comp.MapParams = function(config) {
    Ext.apply(this, config);
};

mx.comp.MapParams = Ext.extend(mx.comp.MapParams, {
    lon: null,
    lat: null,
    zoom: mx.comp.mapComponent.defaultDivisionZoom,
    area: null,
    mapKey: null,
    mapType: null,
    mapIdAndUrl: null,
    region: null,
    regionName: null,
    regionUnresolved: function() {
        return (!this.mapKey || !this.mapType) && this.region;
    },
    valid: function() {
        return (this.mapKey && this.mapType) || this.region;
    },
    setRegionAndPos: function(region, position) {
        if (region && region.data) {
            region = region.data;
        }
        if (position && position.center) {
            this.lat = position.center.lat;
            this.lon = position.center.lon;
            this.zoom = position.zoom;
        } else if (region && !this.area && typeof this.area != 'string') {
            this.area = region.defaultAocBorders;
        }
        if (region) {
            if (!this.mapKey && !this.mapType) {
                this.mapKey = region.map_key;
                this.mapType = region.map_type;
            }
            if (!this.lat && !this.lon && !this.area) {
                if (
                    MXBT.data.defaultMapPosition &&
                    MXBT.data.defaultMapPosition.lat &&
                    MXBT.data.defaultMapPosition.lon &&
                    MXBT.data.defaultMapPosition.zoom
                ) {
                    this.lat = MXBT.data.defaultMapPosition.lat;
                    this.lon = MXBT.data.defaultMapPosition.lon;
                    this.zoom = MXBT.data.defaultMapPosition.zoom;
                } else {
                    this.lat = region.centerLatitude;
                    this.lon = region.centerLongitude;
                    this.zoom = mx.comp.mapComponent.defaultRegionZoom;
                }
            }
            if (!this.clientName && region.client_name) {
                this.clientName = region.client_name;
            }
            if (!this.mapIdAndUrl && region.map_id_and_url) {
                this.mapIdAndUrl = region.map_id_and_url;
            }
            this.regionName = region.name;
        }
        if (this.lon && this.lat && !this.zoom) {
            this.zoom = mx.comp.mapComponent.defaultDivisionZoom;
        }
    },
    apply: function(params) {
        if (params) {
            Ext.apply(this, params);
            this.setRegionAndPos(params.region);
        }
    },
    toArray: function() {
        return [
            this.mapKey,
            this.lat,
            this.lon,
            this.area,
            this.zoom,
            this.mapType,
            this.clientName,
            MXBT.getTranslation('mx.app.core.termins', 'language'),
            this.mapIdAndUrl,
            this.regionName,
        ];
    },
});
